import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "lucide-react";
import { api, Mandate } from "../../lib/api";
import { StatusBadge } from "../StatusBadge";
import { ConnectBankButton } from "./ConnectBankButton";

export function MandateCard() {
  const { data: mandate } = useQuery<Mandate>({ queryKey: ["mandate"], queryFn: () => api.get("/mandates/current").then((r) => r.data) });
  const status = mandate?.status || (mandate ? "none" : "loading");
  return (
    <div className="border border-border bg-[var(--parchment)] p-8" data-testid="mandate-card">
      <div className="flex items-start justify-between gap-6">
        <div>
          <div className="eyebrow">Direct Debit mandate</div>
          <h2 className="mt-2 font-serif text-2xl sm:text-3xl">{status === "loading" ? "Checking your mandate…" : status === "active" ? "Bank account connected" : status === "pending" ? "Awaiting bank confirmation" : "Connect your bank"}</h2>
          <p className="mt-3 max-w-md text-sm text-neutral-600">
            {status === "active"
              ? `Mandate ${mandate?.gc_mandate_id} is active. Top-ups and recurring plans are collected by GoCardless and credited once confirmed (usually 3 working days).`
              : "Set up a GoCardless Direct Debit mandate right here to top up your cellar without cards."}
          </p>
        </div>
        <ShieldCheck className="h-8 w-8 shrink-0 text-[var(--moss)]" strokeWidth={1} />
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-4">
        {status !== "loading" && <StatusBadge status={status} testId="mandate-status" />}
        {(status === "cancelled" || status === "failed" || status === "expired") && <span className="text-sm text-[var(--wine)]">Your previous mandate ended. Set up a new one to keep topping up.</span>}
      </div>
      {status !== "active" && status !== "loading" && <ConnectBankButton className="mt-6 max-w-sm" label={status === "pending" ? "Restart bank setup" : "Set up Direct Debit"} />}
    </div>
  );
}
